import React from 'react';
import { useWidgetContext } from '../context/WidgetContext';
import EmptyState from './EmptyState';
// import BetBuilderHeader from './BetBuilderHeader';
import EventGroup from './EventGroup';
import { buildInternalGroupedEvents } from '../utils/utils';
// import { useI18n } from '../context/I18nContext';

const BetBuilder: React.FC = () => {
  const { bets, totalOdds, id, config } = useWidgetContext();
  const groupedBets = buildInternalGroupedEvents(bets);
  
  // const { t } = useI18n();
  
  // why use a filtering function here? this seems simpler:
  // const calculatedOdds = totalOdds.find(({ eventId }) => eventId.toString() === group.EventId.toString())?.odd ?? -1
  return (
    <div id ={id} className="bet-builder-widget rounded-lg border border-border bg-background shadow-sm overflow-hidden w-full">
      {/* commenting out because there's no clear-all button in the design */}
      {/*<BetBuilderHeader />*/}

      <div>
        {groupedBets.length === 0 && config.showEmptyState ? (
          <EmptyState />
        ) : (
          <div className="events-border">
            {groupedBets.map(group => (
              <EventGroup key={group.EventId} group={group} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BetBuilder;
